(() => {
  const productScroll = function () {
    const sliders = document.querySelectorAll(".deals__slider");
    if (!sliders) return;

    sliders.forEach((slider) => {
      const slide = slider.querySelector(".deals__list");
      const nextButtons = slider.querySelectorAll(".pro-next");
      const prevButtons = slider.querySelectorAll(".pro-prev");
      const sampleItem = slide.querySelector(".deals__item");

      // Verifica si hay un ítem de muestra para calcular el ancho
      if (!sampleItem) return;

      const itemStyle = getComputedStyle(sampleItem);
      const itemWidth = sampleItem.offsetWidth;
      const itemMargin =
        parseFloat(itemStyle.marginLeft) + parseFloat(itemStyle.marginRight);

      const totalItemWidth = itemWidth + itemMargin; // Ancho total incluyendo el margen
      const slideSteps = 2;
      let position = 0;

      const translateX = function (position) {
        slide.style.left = `${position * -totalItemWidth}px`;
      };

      const getItemCount = function (parent) {
        return Array.from(parent.children).filter(
          (child) => child.nodeType === 1
        ).length;
      };

      const getHiddenItems = function () {
        const totalItems = getItemCount(slide);
        const visibleItems = Math.floor(slider.offsetWidth / totalItemWidth);
        return totalItems - visibleItems;
      };

      const updateButtonVisibility = function () {
        if (position <= 0) {
          prevButtons.forEach((button) => (button.style.display = "none"));
        } else {
          prevButtons.forEach((button) => (button.style.display = "flex"));
          prevButtons.forEach((button) => (button.disabled = false));
        }

        if (position >= getHiddenItems()) {
          nextButtons.forEach((button) => (button.style.display = "none"));
        } else {
          nextButtons.forEach((button) => (button.style.display = "flex"));
          nextButtons.forEach((button) => (button.disabled = false));
        }
      };

      const updatePosition = function (step) {
        const hiddenItems = getHiddenItems();
        position = Math.min(Math.max(position + step, 0), hiddenItems);
        translateX(position);

        updateButtonVisibility();
      };

      const checkIfArrowsNeeded = function () {
        const totalItems = getItemCount(slide);
        const visibleItems = Math.floor(slider.offsetWidth / totalItemWidth);

        if (totalItems <= visibleItems) {
          nextButtons.forEach((button) => (button.style.display = "none"));
          prevButtons.forEach((button) => (button.style.display = "none"));
        } else {
          updateButtonVisibility();
        }
      };

      prevButtons.forEach((button) => {
        button.addEventListener("click", () => {
          updatePosition(-slideSteps);
          checkIfArrowsNeeded();
        });
      });

      nextButtons.forEach((button) => {
        button.addEventListener("click", () => {
          updatePosition(slideSteps);
          checkIfArrowsNeeded();
        });
      });

      // Inicialmente verifica la visibilidad de los botones
      checkIfArrowsNeeded();
    });
  };

  productScroll();
})();
